import { captureException } from '@sentry/react'
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { getSavedState, isSaveStateKeyValid, SavedState } from '../utils/redirectState'

export function useUrlStateParam() {
	const { search } = useLocation()
	const navigate = useNavigate()

	return useMemo(() => {
		const params = new URLSearchParams(search)
		const stateParam = params.get('state')

		let state: SavedState | undefined

		if (stateParam) {
			if (isSaveStateKeyValid(stateParam)) {
				state = getSavedState(stateParam) || undefined
			} else {
				captureException(new Error('Invalid stateParam detected'))
				navigate('/', { replace: true })
			}
		}

		return [state, params.get('error'), params.get('error_description')] as const
	}, [search, navigate])
}
